import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from './components/Footer';

// Define interface for event data
interface EventData {
  mainHeader: string;
  secHeader: string;
  subHeader: string;
  first_content: string;
  extra_text: string;
  second_content: string;
  images: { src: string; position: 'top' | 'bottom' }[];
  video: string;
}

const ExpertCards: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [imageLoaded, setImageLoaded] = useState<Record<number, boolean>>({});
  const [videoLoaded, setVideoLoaded] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (): void => {
    navigate('/events');
  };

  const handleImageLoad = (index: number): void => {
    setImageLoaded(prev => ({ ...prev, [index]: true }));
  };

  const handleVideoLoad = (): void => {
    setVideoLoaded(true);
  };

  const datas: EventData[] = [
    {
      mainHeader: 'Trios Pozer Logo Revealing in Dubai Mall',
      secHeader: 'Company Launching Soon in Dubai',
      subHeader: 'Logo Launching in Dubai',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/item_1_1.jpeg', position: 'top' },
        { src: '/assets/item_1_2.jpeg', position: 'bottom' },
        { src: '/assets/item_1_3.jpeg', position: 'top' },
        { src: '/assets/item_1_2.jpeg', position: 'bottom' },
      ],
      video: '/assets/item_1.mp4',
    },
    {
      mainHeader: 'Wahj Mart In Dubai',
      secHeader: 'Pozer System Installation',
      subHeader: 'Inaguration',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/wahjMart_1.png', position: 'top' },
        { src: '/assets/wahjMart_2.png', position: 'bottom' },
        { src: '/assets/wahjMart_3.png', position: 'top' },
        { src: '/assets/wahjMart_4.png', position: 'bottom' },
      ],
      video: '/assets/wahjMart_video.mp4',
    },
    {
      mainHeader: 'Trios Pozer Logo Revealing in Dubai Mall',
      secHeader: 'Company Launching Soon in Dubai',
      subHeader: 'Logo Launching in Dubai',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/jenan_02.png', position: 'top' },
        { src: '/assets/jenan_03.png', position: 'bottom' },
        { src: '/assets/jenan_04.png', position: 'top' },
        { src: '/assets/jenan_05.png', position: 'bottom' },
      ],
      video: '/assets/jenan.mp4',
    },
    {
      mainHeader: 'Trios Winter Party 2024',
      secHeader: 'Our Contributing Team',
      subHeader: 'Team is All...',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/item_2_1.png', position: 'top' },
        { src: '/assets/item_2_2.png', position: 'bottom' },
        { src: '/assets/item_2_3.png', position: 'top' },
        { src: '/assets/item_2_4.png', position: 'bottom' },
      ],
      video: '/assets/item_2.mp4',
    },
    {
      mainHeader: 'Fish Market POS Installation',
      secHeader: 'Al Thayyib Fish Market',
      subHeader: 'Pozer POS System Install',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/item_3_1.png', position: 'top' },
        { src: '/assets/item_3_2.png', position: 'bottom' },
        { src: '/assets/item_3_3.png', position: 'top' },
        { src: '/assets/item_3_4.png', position: 'bottom' },
      ],
      video: '/assets/item_3.mp4',
    },
    {
      mainHeader: 'Dream Land Dubai',
      secHeader: 'Pozer System Installation',
      subHeader: 'Installing & Overview',
      first_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, reprehenderit quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      extra_text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo quia excepturi saepe. Ad, atque. Porro architecto non, представляющий quam perspiciatis vitae. A suscipit voluptatum quasi, placeat commodi dolor possimus sapiente dolores id tenetur eveniet',
      second_content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur veniam recusandae incidunt odit ad at adipisci, eaque laborum ipsam qui animi cumque culpa voluptatem quo',
      images: [
        { src: '/assets/item_5_1.png', position: 'top' },
        { src: '/assets/item_5_2.png', position: 'bottom' },
        { src: '/assets/item_5_3.png', position: 'top' },
        { src: '/assets/item_5_2.png', position: 'bottom' },
      ],
      video: '/assets/item_5.mp4',
    },
  ];

  const index = Number(id);
  const data = datas[index - 1];

  if (!data) {
    return <h1 className="text-center mt-20">Event not found</h1>;
  }

  return (
    <>
      <div className="w-full max-w-7xl mx-auto font-sfui px-4 pb-20 relative bg-white md:mt-10 mt-14">
        {/* absolute portion */}
        <div className="absolute w-52 h-52 bg-[#bb8624] z-30 rounded-full blur-[100px]"></div>
        <div className="absolute w-52 h-52 left-10 bottom-0 z-30 bg-[#bb8624] rounded-full blur-[100px]"></div>
        <div className="absolute w-52 h-52 right-[50%] top-[40%] z-30 bg-[#bb8624] rounded-full blur-[100px]"></div>
        <div className="absolute w-52 h-52 right-0 top-10 z-30 bg-[#bb8624] rounded-full blur-[100px]"></div>

        <div
          className="absolute md:flex hidden h-5 md:h-8 px-5 justify-center items-center rounded-full bg-red-500 text-white -top-5 left-2 cursor-pointer z-50"
          onClick={handleChange}
        >
          Back
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="ms-1 icon icon-tabler icons-tabler-outline icon-tabler-arrow-back-up"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M9 14l-4 -4l4 -4" />
            <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
          </svg>
        </div>

        <section className="text-center mt-24 md:mb-10 mb-5 flex flex-wrap gap-5 md:gap-0 z-40">
          <div className="w-full flex flex-col md:flex-row">
            <div className="w-full z-40 h-full flex justify-center items-center">
              {data.video ? (
                <div className="relative max-w-md mx-auto rounded-md">
                  {!videoLoaded && (
                    <div className="absolute inset-0 animate-pulse bg-gray-200 rounded-md">
                      <div className="w-full h-full bg-[length:200%_100%] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[gradient_2s_linear_infinite]"></div>
                    </div>
                  )}
                  <video
                    src={data.video}
                    controls
                    autoPlay
                    loop
                    playsInline
                    muted
                    className={`rounded-md md:w-fit w-full max-h-[400px] max-w-md mx-auto transition-opacity duration-500 ease-in-out ${
                      videoLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                    }`}
                    onCanPlay={handleVideoLoad}
                  />
                </div>
              ) : (
                <p className="text-center">No video available</p>
              )}
            </div>
          </div>
        </section>

        {/* Desktop layout */}
        <div className="hidden md:block relative mt-24">
          <div className="grid grid-cols-4 md:px-20 gap-6 relative z-40">
            {data.images.map((item, index) => (
              <div
                key={index}
                className={`transform relative ${item.position === 'top' ? '-translate-y-8' : 'translate-y-8'}`}
              >
                <div className="bg-white z-40 relative rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105">
                  {item.src ? (
                    <div className="relative w-full h-64">
                      {!imageLoaded[index] && (
                        <div className="absolute inset-0 animate-pulse bg-gray-200">
                          <div className="w-full h-full bg-[length:200%_100%] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[gradient_2s_linear_infinite]"></div>
                        </div>
                      )}
                      <img
                        src={item.src}
                        alt={`item ${index + 1}`}
                        className={`w-full h-64 object-cover transition-opacity duration-500 ease-in-out ${
                          imageLoaded[index] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                        }`}
                        onLoad={() => handleImageLoad(index)}
                      />
                    </div>
                  ) : (
                    <p className="text-center">No image available</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile layout */}
        <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-6 z-40">
          {data.images.map((item, index) => (
            <div key={index} className="bg-white rounded-lg z-40 relative overflow-hidden shadow-lg">
              {item.src ? (
                <div className="relative w-full h-64">
                  {!imageLoaded[index] && (
                    <div className="absolute inset-0 animate-pulse bg-gray-200">
                      <div className="w-full h-full bg-[length:200%_100%] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[gradient_2s_linear_infinite]"></div>
                    </div>
                  )}
                  <img
                    src={item.src}
                    alt={`Expert ${index + 1}`}
                    className={`w-full h-64 object-cover transition-opacity duration-500 ease-in-out ${
                      imageLoaded[index] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                    }`}
                    onLoad={() => handleImageLoad(index)}
                  />
                </div>
              ) : (
                <p className="text-center">No image</p>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExpertCards;